import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchCollectionWithPost } from '@app/src/api/fetchHooks'
import Table from '@app/src/components/Table'
import usePaginationWithQuery from '@app/src/hooks/paginationWithQuery'
import { SortOrder } from '@app/src/types/filter'
import type { User } from '@app/src/types/resourceExplorer'
import { Box } from '@mui/material'
import React from 'react'
import ColleagueHeader from './ColleagueHeader'
import ColleagueRow from './ColleagueRow'

const ColleaguesTable: React.FC = () => {
  const [page, pageSize, setPage, setPageSize] = usePaginationWithQuery()

  const { items, count, isLoading, isFetching, isError } = useFetchCollectionWithPost<User>({
    key: FetchKey.Colleague,
    endpoint: endpoints.colleagues,
    payload: {
      filter: [],
      include: ['*'],
      pagination: {
        pageNumber: page,
        itemsPerPage: pageSize,
      },
      sort: {
        order: SortOrder.ASCENDING,
        target: 'name',
      },
    },
  })

  return (
    <Box flexGrow={1} display="flex" flexDirection="column" height={100}>
      <Table<User>
        HeaderComponent={ColleagueHeader}
        RowComponent={ColleagueRow}
        count={count}
        data={items}
        isLoading={isLoading || isFetching}
        isError={isError}
        page={page}
        pageSize={pageSize}
        setPage={setPage}
        setPageSize={setPageSize}
      />
    </Box>
  )
}

export default ColleaguesTable
